export const CDP_GET_PORTFOLIO_TOKEN_BALANCES = 'cdp_getTokensForAddresses';
export const CDP_GET_PRICE_QUOTE = 'cdp_getPriceQuote';
